import { FC } from 'react';

const SkeletonBlock: FC<{ className?: string }> = ({ className }) => (
  <div className={`animate-pulse rounded-2xl bg-secondary-100 ${className ?? ''}`} />
);

export const EmailTemplateListLoadingState: FC = () => {
  return (
    <div className='space-y-5' aria-busy='true' aria-live='polite'>
      <div className='grid gap-4 rounded-2xl border border-secondary-border bg-white p-4 sm:grid-cols-2'>
        <div className='space-y-2'>
          <SkeletonBlock className='h-3 w-24' />
          <SkeletonBlock className='h-8 w-16' />
        </div>
        <div className='space-y-2'>
          <SkeletonBlock className='h-3 w-28' />
          <SkeletonBlock className='h-8 w-12' />
        </div>
      </div>

      <div className='space-y-3 rounded-2xl border border-secondary-border bg-white p-4'>
        <div className='flex items-center justify-between gap-3'>
          <SkeletonBlock className='h-3 w-32' />
          <SkeletonBlock className='h-4 w-20' />
        </div>
        <div className='flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between'>
          <div className='flex flex-wrap gap-2'>
            <SkeletonBlock className='h-9 w-16 rounded-full' />
            <SkeletonBlock className='h-9 w-24 rounded-full' />
            <SkeletonBlock className='h-9 w-20 rounded-full' />
          </div>
          <SkeletonBlock className='h-10 w-full max-w-sm' />
        </div>
      </div>

      <div className='grid gap-4 md:grid-cols-2 xl:grid-cols-4'>
        {Array.from({ length: 4 }).map((_, index) => (
          <div key={index} className='space-y-3 rounded-2xl border border-secondary-border bg-white p-4'>
            <SkeletonBlock className='h-6 w-20 rounded-full' />
            <SkeletonBlock className='h-4 w-3/4' />
            <div className='space-y-2'>
              <SkeletonBlock className='h-3 w-16' />
              <SkeletonBlock className='h-12 w-full rounded-lg' />
            </div>
            <SkeletonBlock className='h-3 w-28' />
          </div>
        ))}
      </div>
    </div>
  );
};
